import { __assign, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '../utils';
import styles from './Link.module.css';
import tokens from '@metro-ui/tokens/css/custom-properties.module.css';
export var Link = React.forwardRef(function (_a, ref) {
    var _b;
    var href = _a.href, isNotUnderlined = _a.isNotUnderlined, _c = _a.isUnderlined, isUnderlined = _c === void 0 ? true : _c, isMuted = _a.isMuted, isDisabled = _a.isDisabled, isInverted = _a.isInverted, isFullWidth = _a.isFullWidth, isButton = _a.isButton, Icon = _a.Icon, _d = _a.iconPosition, iconPosition = _d === void 0 ? 'left' : _d, onClick = _a.onClick, Component = _a.Component, color = _a.color, forwardedProps = _a.forwardedProps, title = _a.title, _e = _a.className, className = _e === void 0 ? '' : _e, children = _a.children, htmlAttributes = __rest(_a, ["href", "isNotUnderlined", "isUnderlined", "isMuted", "isDisabled", "isInverted", "isFullWidth", "isButton", "Icon", "iconPosition", "onClick", "Component", "color", "forwardedProps", "title", "className", "children"]);
    var iconTag = Icon ? React.createElement(Icon, { className: styles.mdsCompLinkIcon }) : null;
    var Tag = Component || (href ? 'a' : 'button');
    var clickHandler = function (event) {
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        if (onClick) {
            onClick(event, href);
        }
    };
    var linkClassNames = classNames((_b = {},
        _b[tokens.mdsComp] = true,
        _b[styles.mdsCompLink] = true,
        _b[styles.isFullWidth] = !!isFullWidth,
        _b[styles.isNotUnderlined] = !!isNotUnderlined,
        _b[styles.isUnderlined] = isUnderlined,
        _b[styles.isMuted] = !!isMuted,
        _b[styles.isDisabled] = !!isDisabled,
        _b[styles.isButton] = !!isButton,
        _b[styles.isInverted] = color === 'inverted' || !!isInverted,
        _b[styles.hasIcon] = !!Icon,
        _b[styles.iconLeft] = iconPosition === 'left',
        _b[styles.iconRight] = iconPosition === 'right',
        _b[className] = !!className,
        _b));
    return (React.createElement(Tag, __assign({}, (isDisabled ? { tabIndex: -1 } : {}), htmlAttributes, forwardedProps, { className: linkClassNames, onClick: clickHandler, href: isDisabled ? '' : href, "aria-disabled": isDisabled, ref: ref, title: title }),
        iconPosition === 'left' && iconTag,
        children,
        iconPosition === 'right' && iconTag));
});
export var LinkPropTypes = {
    href: PropTypes.string,
    isUnderlined: PropTypes.bool,
    isMuted: PropTypes.bool,
    isInverted: PropTypes.bool,
    isFullWidth: PropTypes.bool,
    Icon: PropTypes.func,
    iconPosition: PropTypes.oneOf(['left', 'right']),
    onClick: PropTypes.func,
    Component: PropTypes.elementType,
    title: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
};
Link.propTypes = LinkPropTypes;
//# sourceMappingURL=Link.js.map